import { tool } from "@/libs/tool";
import Alert from "@/comm/alert";
import customTransform from "@/lang/customTransform.js";
let Obj = {
  install: function (Vue, option) {
    Alert(Vue);
    //添加指令
    Vue.prototype.$tool = tool;
    Vue.prototype.$transform = (word) => {
      if (tool.GetUrlPara("lang") == "en") {
        return word;
      } else {
        return customTransform[word] || word;
      }
    };
    Vue.directive("transform", {
      // 当被绑定的元素插入到 DOM 中时……
      inserted: function (el, binding) {
        if (tool.GetUrlPara("lang") == "en") {
          el.innerText = word;
          return;
        }
        let word = binding.value;

        if (word) {
          el.innerText = customTransform[word] || word;
        }
        //  el.innerText =
      },
    });
    Vue.prototype.$getCountryISO2 = (key) => {
      let obj = {
        ARGENTINA: "ar",
        AUSTRALIA: "au",
        BRAZIL: "br",
        BRITAIN: "gb",
        CANADA: "ca",
        CHINA: "cn",
        FRANCE: "fr",
        EURO: "eu", //??
        GERMANY: "de",
        INDIA: "in",
        INDONESIA: "id",
        ITALY: "it",
        JAPAN: "jp",
        MEXICO: "mx",
        RUSSIA: "ru",
        "SAUDI ARABIA": "sa",
        "SOUTH AFRICA": "za",
        "SOUTH KOREA": "kr",
        TURKEY: "tr",
        "UNITED STATES": "us",
      };
      return obj[key] || "";
    };
  },
};
export default Obj;
